import React, { useState } from "react";
import "./LoginPage.css";
import { Container, Form } from "react-bootstrap";
import OrangeFilledRoundBtn from "../Common-Component/Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import Logo from "../Common-Component/Reset_Flow/Logo/Logo";
import Heading from "../Common-Component/Reset_Flow/Heading/Heading";
import Banner from "../Common-Component/Reset_Flow/Banner/Banner";
import { Link, useNavigate } from "react-router-dom";
import BrownSuccessFullModal from "../Common-Component/Common_Modal/BrownSuccessFullModal/BrownSuccessFullModal";
import { useForm } from "react-hook-form";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { UserLogin } from "../../features/auth/authSlice";

export default function LoginPage() {

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    }
  };

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const dispatch = useDispatch();
  const onSubmit = async (data) => {
   
    
    const res = await dispatch(UserLogin(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSuccessModal(true);
      setTimeout(() => {
        navigate("/home");
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
    
      if (res.payload?.errors?.email_or_contact) {
        setError("email_or_contact", {
          type: "manual",
          message: res.payload?.errors?.email_or_contact,
        });
      }
      if (res.payload?.errors?.password) {
        setError("password", {
          type: "manual",
          message: res.payload?.errors?.password,
        });
      }
    }
  };

 
  return (
    <section className="login-page">
      <Container>
        <div className="card_holder login-card">
          <Logo />
          <Heading headingText={"WELCOME BACK!"} />
          <p className="subtext">
            We're Glad To See You Again. Please Enter Your Credentials To Access
            Your Account.
          </p>
          <Form className="login-form" onSubmit={handleSubmit(onSubmit)}>


            <Form.Group className="form-group">
              <Form.Control
                type="text" 
                name="email_or_contact"
                placeholder="Email / Mobile Number"
                {...register("email_or_contact", {
                  required: "Credentials required",
                })}
                className={classNames("", {
                  "is-invalid": errors?.email_or_contact,
                  "is-valid": getValues("email_or_contact"),
                })}
              />
              {errors?.email_or_contact && (
                <sup className="text-danger">{errors?.email_or_contact?.message}</sup>
              )}
            </Form.Group>

            <Form.Group className="form-group password_holder">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password*"
                name="password"
                {...register("password", {
                  required: "Password is required",
                })}
                className={classNames("", {
                  "is-invalid": errors?.password,
                  "is-valid": getValues("password"),
                })}
              />
              {errors?.password && (
                <sup className="text-danger">{errors?.password?.message}</sup>
              )}
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconOne}
                  className="icon"
                  onClick={() => togglePasswordVisibility("password")}
                />
              </div>

            </Form.Group>

            <Link
              to={"/reset-pass"}
              className="d-flex justify-content-end pass-text"
            >
              Forgot Password?
            </Link>

            <div className="login-btn text-center">
              <OrangeFilledRoundBtn
                btnText={"Login"}
                type={'submit'}
                // onClick={handleSubmit(onSubmit)}
              />
            </div>
          </Form>

          <div className="btm-text">
            <Link to={"/sign-up"}>
              <p className="acc-creation">Create account?</p>
            </Link>
            {/* <p className="social">or login with social accounts</p>
            <img
              src={process.env.PUBLIC_URL + "/assets/Images/Icons/google.png"}
              className="google-img"
              alt="google-img"
            /> */}
          </div>

          {/* <div className="home-link text-center mt-2" >
            <Link to={"/home"}>
              Back to Home
              <span>
                <i class="fa-solid fa-angle-right arrow">‌</i>
              </span>
            </Link>
          </div> */}

        </div>
        <div className="img-holder">
          <Banner />
        </div>
      </Container>

      <BrownSuccessFullModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText="Welcome back!"
        successText2="You've logged in successfully"
      />
    </section>
  );
}
